import React from 'react'

import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import { Bar } from 'react-chartjs-2'

import applicationStatusConstants from 'utils/constants/statusConstants'

const renderApplicationStatus = (status, theme) => {
  let elemStatus = null
  if (status === applicationStatusConstants.ERROR) {
    const color = theme.palette.primary.red
    elemStatus = (
      <React.Fragment>
        <ErrorIcon style={{ color: color,  marginRight: '4px' }} />
        <span>Sistema de origem fora do ar</span>
      </React.Fragment>
    )
  } else if (status === applicationStatusConstants.OK) {
    const color = theme.palette.primary.green
    elemStatus = (
      <React.Fragment>
        <CheckCircleIcon style={{ color: color, marginRight: '4px' }} />
        {applicationStatusConstants.OK}
      </React.Fragment>
    )
  } else if (status === applicationStatusConstants.PARTIAL) {
    const color = theme.palette.primary.yellow
    elemStatus = (
      <React.Fragment>
        <RemoveCircleIcon style={{ color: color, marginRight: '4px' }} />
        Sistema de origem com instabilidade
      </React.Fragment>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {elemStatus}
    </div>
  )
}

const renderAnalyticsMetric = (analytics, theme) => {
  const labels = [
    '72 horas',
    '48 horas',
    '24 horas',
    '12 horas',
    '6 horas',
    '2 horas',
    '1 hora',
  ]

  const data = {
    labels,
    datasets: [
      {
        label: 'OK',
        data: labels.map((label) => {
          let percent
          switch (label) {
            case '1 hora':
              percent = analytics.last_1_hours.with_ok
              break
            case '2 horas':
              percent = analytics.last_2_hours.with_ok
              break
            case '6 horas':
              percent = analytics.last_6_hours.with_ok
              break
            case '12 horas':
              percent = analytics.last_12_hours.with_ok
              break
            case '24 horas':
              percent = analytics.last_24_hours.with_ok
              break
            case '48 horas':
              percent = analytics.last_48_hours.with_ok
              break
            case '72 horas':
              percent = analytics.last_72_hours.with_ok
              break
            default:
              percent = 0
              break
          }
          return percent
        }),
        stack: 'Stack 0',
        backgroundColor: theme.palette.primary.green,
      },
      {
        label: 'Erro',
        data: labels.map((label) => {
          let percent
          switch (label) {
            case '1 hora':
              percent = analytics.last_1_hours.with_error
              break
            case '2 horas':
              percent = analytics.last_2_hours.with_error
              break
            case '6 horas':
              percent = analytics.last_6_hours.with_error
              break
            case '12 horas':
              percent = analytics.last_12_hours.with_error
              break
            case '24 horas':
              percent = analytics.last_24_hours.with_error
              break
            case '48 horas':
              percent = analytics.last_48_hours.with_error
              break
            case '72 horas':
              percent = analytics.last_72_hours.with_error
              break
            default:
              percent = 0
              break
          }
          return percent
        }),
        stack: 'Stack 0',
        backgroundColor: theme.palette.primary.red,
      },
    ],
  }

  const options = {
    plugins: {
      title: {
        display: false,
      },
    },
    responsive: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  }

  return <Bar options={options} data={data} />
}

export const tableColumns = (theme) => {
  return [
    {
      name: 'app_id',
      label: 'Serviço',
    },
    {
      name: 'success_rate',
      label: 'Porcentagem de Sucesso',
      options: {
        setCellHeaderProps: () => { return { style: { textAlign: 'center' } } },
        setCellProps: () => { return { style: { textAlign: 'center' } } },
        customBodyRender: (value) => (
          `${value}%`
        ),
      },
    },
    {
      name: 'current_status',
      label: 'Status',
      options: {
        customBodyRender: (value) => (
          renderApplicationStatus(value, theme)
        ),
      },
    },
    {
      name: 'analytics_metric',
      label: 'Histórico de métricas',
      options: {
        customBodyRender: (value) => (
          renderAnalyticsMetric(value, theme)
        ),
      },
    },
  ]
}
